import { render, staticRenderFns } from "./AddEditPortModal.vue?vue&type=template&id=5aa5cb4a&scoped=true&"
import script from "./AddEditPortModal.vue?vue&type=script&lang=js&"
export * from "./AddEditPortModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5aa5cb4a",
  null
  
)

export default component.exports